import { ApiError } from "./client";

// Local-only dev endpoints (backend/src/routes/dev.ts) — never mounted at all in production
// (index.ts only app.use()s this router when NODE_ENV !== "production"), so no auth token is
// sent or required. Mirrors apiFetch's base-URL and error-handling conventions without the
// user/token parameter apiFetch requires, per the project's "no raw fetch in components" rule.
const BASE = process.env.REACT_APP_API_URL ?? "";

async function devFetch<T>(path: string, init?: RequestInit): Promise<T> {
  const res = await fetch(`${BASE}${path}`, { method: "POST", ...init });
  const body = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new ApiError(res.status, body.error ?? res.statusText);
  }
  return body;
}

export function resetDevData(): Promise<{ ok: boolean; message: string }> {
  return devFetch("/dev/reset");
}

export function runDevFplPoll(): Promise<{ ok: boolean; message: string }> {
  return devFetch("/dev/fpl-poll");
}

export function runDevTestEmail(kind: "alert" | "success" = "alert"): Promise<{ ok: boolean; message: string }> {
  return devFetch(`/dev/test-email?kind=${kind}`);
}
